import { useState } from 'react';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import { useSearchParams as useUrlSearchParams } from 'react-router-dom';
import { adminStyles } from '../../../theme/adminStyles';
import i18next from 'i18next';
import LoginHistoryTab from './LoginHistoryTab';
import SystemLogTab from './SystemLogTab';
import ServerLogTab from './ServerLogTab';

const ServiceStatusPage = () => {
  // URL クエリと同期 (戻るボタンでタブ状態を復元するため)
  const [urlParams, setUrlParams] = useUrlSearchParams();
  const [tabIndex, setTabIndex] = useState(() => {
    const t = parseInt(urlParams.get('tab') || '0', 10);
    return isNaN(t) ? 0 : t;
  });

  const handleTabChange = (v: number) => {
    setTabIndex(v);
    const next = new URLSearchParams();
    if (v > 0) next.set('tab', String(v));
    setUrlParams(next, { replace: true });
  };

  return (
    <Container maxWidth={false} sx={adminStyles.fullWidthPageContainer}>
      <Box sx={adminStyles.headerBox}>
        <Typography variant="h4" sx={adminStyles.pageTitle}>
          {i18next.t('nav.service_status')}
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tabIndex} onChange={(_, v) => handleTabChange(v)}>
          <Tab label={i18next.t('service_status.login_history')} />
          <Tab label={i18next.t('service_status.system_log')} />
          <Tab label={i18next.t('service_status.server_log')} />
        </Tabs>
      </Box>

      {tabIndex === 0 && <LoginHistoryTab />}
      {tabIndex === 1 && <SystemLogTab />}
      {tabIndex === 2 && <ServerLogTab />}
    </Container>
  );
};

export default ServiceStatusPage;
